import { Box } from "@mui/material"
import { alpha } from "@mui/material/styles"

export function StructuredRichTextPreview({ dataCy, html }) {
    return (
        <Box
            className="styled-bullets"
            sx={(theme) => ({
                fontSize: 12,
                lineHeight: 1.5,
                color: "text.secondary",
                wordBreak: "break-word",
                "& p": {
                    fontSize: "inherit",
                    lineHeight: "inherit",
                    color: "inherit",
                    m: 0,
                },
                "& li": {
                    fontSize: "inherit",
                    lineHeight: "inherit",
                    color: "inherit",
                },
                "& ul, & ol": {
                    my: 0,
                },
                '& span[data-structured-diff="new"]': {
                    color: "primary.main",
                    backgroundColor: alpha(theme.palette.primary.main, 0.08),
                    borderRadius: "4px",
                    padding: "2px 3px",
                    margin: "0 -3px",
                    boxDecorationBreak: "clone",
                    WebkitBoxDecorationBreak: "clone",
                },
                '& span[data-structured-diff="removed"]': {
                    color: "error.main",
                    textDecoration: "line-through",
                    backgroundColor: alpha(theme.palette.error.main, 0.08),
                    borderRadius: "4px",
                    padding: "2px 3px",
                    margin: "0 -3px",
                    boxDecorationBreak: "clone",
                    WebkitBoxDecorationBreak: "clone",
                },
            })}
            data-cy={dataCy}
            dangerouslySetInnerHTML={{ __html: html ?? "" }}
        />
    )
}
